/**
 *
 *@typedef {Object} Cell
 @property {Number} $id
 */
/**
 *@typedef {Object} Record
 *@property {Number} id
 *@property {String} name
 *@property {String} status
 *@property {String} created_at
 *@property {String} updated_at
 */

/**
 *
 *@typedef {Object} Data
  @property {Array<Cell>} data
  @property {Number} id
  @property {String} name
  @property {String} status
  @property {String} created_at
  @property {String} updated_at
 */

/**
 *
 *@typedef {Object} DataState
 @property {String} stage
 @property {Data} record
 @property {Array<Record>} uploads
 @property {Array<Object>} records
 @property {Array<Cell>} editting
 @property {Array<Array<Cell>>} history
 @property {Array<NormalizationEntry>} normalizationResponse
 @property {D_CheckResponse} duplicateCheckResponse
 @property {D_CheckResponse} DBduplicateCheckResponse
 @property {Boolean} isNormalized
 @property {Boolean} hasPassedDuplicatesCheck
 @property {Boolean} hasPassedDBDuplicatesCheck
 @property {File} file
 @property {String} fileURL
 */

import { UPLOAD_STAGE } from "../../../store/stages";

/**
 *
 * @returns {DataState}
 */
const defaulState = () => ({
  /**
   * @type String
   */
  stage: UPLOAD_STAGE,
  /**
   * Holds the current object being uploaded
   * @type {(Data|undefined)}
   */
  record: null,

  /**
   * Holds a reference to a file selected for upload
   * this is necessary to hold current file
   * @type {File}
   */
  file: null,

  /**
   * @type {String}
   */
  fileURL: null,

  /**
   * Holds a list of all uploads
   * @type {Array<Record>}
   */
  uploads: [],

  /**
   * Holds a list of all fetched records
   * @type {Array<Object>}
   */
  records: [],

  /**
   *
   */
  isNormalized: false,

  /**
   *
   */
  hasPassedDuplicatesCheck: false,

  /**
   *
   */
  hasPassedDBDuplicatesCheck: false,

  /**
   * @type {(Array<Cell>|undefined)}
   */
  editting: [],

  /**
   *@type {(Array<NormalizationEntry>|undefined)}
   */
  normalizationResponse: null,

  /**
   * @type {(D_CheckResponse|undefined)}
   */
  duplicateCheckResponse: null,

  /**
   * @type {(D_CheckResponse|undefined)}
   */
  DBduplicateCheckResponse: null,

  /**
   * Holds  editting histories, mimicks a stack data object
   * for implementing undo and redo functionalities
   * @type {Array<Array<Cell>>}
   */
  history: [],
  dataType: "Data",
});

export default defaulState;
